module.exports = __webpack_public_path__ + "img/down.8b7cd299.svg";